import { useQuery } from '@tanstack/react-query';
import { useRequest } from '~/lib/useRequest';
import { IntakeManagementPagePropsResponse } from '@ab/ams-school-api/types/private/v1';

import { config } from '~/config';

export type ReferenceData = IntakeManagementPagePropsResponse['referenceData'];
export type InitialQueryParameter = {
  searchQuery?: string;
  pageSize: number;
};

export type IntakeManagementPageInitialProps = IntakeManagementPagePropsResponse;

export function useIntakeManagementPageProps() {
  const request = useRequest();
  const { isLoading, data, isError, error } = useQuery({
    queryKey: ['useIntakeManagementPageProps'],
    queryFn: async () => {
      const response = await request<IntakeManagementPagePropsResponse>(
        `${config.apiHost}/private/v1/intakes/page_props`,
        {
          isExpectedResponse,
        }
      );

      return response;
    },
  });
  return {
    isInitialPropsError: isError,
    initialPropsError: error,
    isLoadingInitialProps: isLoading,
    initialProps: data,
  };
}

function isExpectedResponse(res: unknown): res is IntakeManagementPagePropsResponse {
  return Boolean(res && typeof res === 'object');
}
